// src/features/services/components/ServiceStatusBadge.tsx
import clsx from 'clsx';
import type { ServiceStatus } from './ServiceRow';

const STATUS_CONFIG: Record<ServiceStatus, { label: string; className: string }> = {
  active: {
    label: 'فعال',
    className: 'text-emerald-400 bg-emerald-400/10 border-emerald-400/20',
  },
  expiring: {
    label: 'در حال اتمام',
    className: 'text-amber-400 bg-amber-400/10 border-amber-400/20',
  },
  expired: {
    label: 'منقضی شده',
    className: 'text-rose-400 bg-rose-400/10 border-rose-400/20',
  },
};

interface ServiceStatusBadgeProps {
  status: ServiceStatus;
}

export function ServiceStatusBadge({ status }: ServiceStatusBadgeProps) {
  const { label, className } = STATUS_CONFIG[status];

  return (
    <span
      className={clsx(
        'inline-flex shrink-0 items-center rounded-full border px-2.5 py-1 text-xs font-medium',
        className,
      )}
    >
      {label}
    </span>
  );
}
